<cmps-wait-status *ngIf="state?.pending?.init"></cmps-wait-status>

<ng-container
    *ngIf="
        !state?.pending?.init &&
        state?.permissions &&
        state?.permissions?.length !== 0
    "
>
    <div
        tabset
        [rendererOptions]="opts"
        #tabset="tabset"
    >
        <ng-template tabsetContent>
            <div
                class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-300 ie-tabset"
            ></div>
        </ng-template>

        <ng-template
            tabContent
            let-tab="tab"
            let-ctx="ctx"
        >
            <div class="w-100">
                <div
                    class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 hover:cmps-cdk-pseudo-child ie-tab"
                    [ngClass]="{
                        'cmps-cdk-border-b-color-white active':
                            tab.def.id === state.selectedTab &&
                            ctx.type !== TabType.ADD,
                        'cmps-cdk-border-r-0': tab.def.id === adjacentTabId
                    }"
                    (mouseenter)="onTabMouseEnter($event, tab)"
                    (mouseleave)="onTabMouseLeave($event, tab)"
                    *ngIf="ctx.type !== TabType.ADD"
                >
                    <cmps-icon
                        class="cmps-cdk-fill-grey-300 cmps-cdk-mr-0dot25"
                        svgIcon="account-circle"
                        *ngIf="ctx.type === TabType.HUMAN"
                    ></cmps-icon>
                    <cmps-icon
                        class="cmps-cdk-fill-grey-300 cmps-cdk-mr-0dot25"
                        svgIcon="chart-box-outline"
                        *ngIf="ctx.type === TabType.PERFORMANCE"
                    ></cmps-icon>
                    <span class="hover:cmps-cdk-color-blue-100 label">{{
                        ctx.label
                    }}</span>
                    <button
                        class="btn bg-transparent ie-close"
                        (click)="onTabCloseClick(tab)"
                        *ngIf="!ctx.predefined && !ctx.isDefault"
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400"
                            svgIcon="close"
                        ></cmps-icon>
                    </button>
                </div>
                <div
                    class="ie-tab-add"
                    *ngIf="ctx.type === TabType.ADD"
                >
                    <div
                        class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-blue-100 cmps-cdk-color-blue-100 hover:cmps-cdk-color-grey-400 add"
                    >
                        <cmps-icon
                            [svgIcon]="!wizardIsOpen ? 'plus' : 'minus'"
                        ></cmps-icon>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>

    <div
        class="cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-t-0 ie-content"
        data-insight="root"
        [ngSwitch]="selectedTab?.ctx.type"
    >
        <div
            *ngSwitchCase="TabType.HUMAN"
            cmpsHumanInsight
            [context]="selectedTab.ctx"
            [persistPeriod]="persistPeriod"
            (setDefault)="onSetDefaultTab($event)"
            (setFavourite)="onSetFavouriteTab($event)"
            (addNewTab)="onAddNewTab($event)"
        ></div>
        <div
            *ngSwitchCase="TabType.PERFORMANCE"
            cmpsPerformanceInsight
            [context]="selectedTab.ctx"
            (setDefault)="onSetDefaultTab($event)"
            (setFavourite)="onSetFavouriteTab($event)"
        ></div>
    </div>
</ng-container>
